/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagerefundedordersone4Inputs */

const en_ticketpagerefundedordersone4 = /** @type {(inputs: Ticketpagerefundedordersone4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 order`)
};

const de_ticketpagerefundedordersone4 = /** @type {(inputs: Ticketpagerefundedordersone4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Bestellung`)
};

/**
* | output |
* | --- |
* | "1 order" |
*
* @param {Ticketpagerefundedordersone4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagerefundedordersone4 = /** @type {((inputs?: Ticketpagerefundedordersone4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagerefundedordersone4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagerefundedordersone4(inputs)
	return de_ticketpagerefundedordersone4(inputs)
});
export { ticketpagerefundedordersone4 as "ticketPageRefundedOrdersOne" }